import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IAnnotationReviewStore } from '../annotationReview.store';
import { ReviewMode } from '../models/reviewMode';

interface IProps {
  children: (model: ReviewMode) => ReactElement;
}

export const ReviewModeBuilderContainer = observer((props: IProps): ReactElement => {
  const reviewStore = useInjection(IAnnotationReviewStore.$);

  return props.children(reviewStore.currentMode);
});
